import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import ConfiguratorForm                                       from '../views/configurator-form.vue';

const routes: Array<RouteRecordRaw> = [
  // {
  //   path     : '/',
  //   name     : 'Configurator',
  //   component: ConfiguratorForm,
  // },
  // {
  //   path: '/shop/order-history',
  //   name: 'Shop',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "shop" */ '../views/order-history.vue'),
  // },
  {
    path: '/shop/model',
    name: 'Model',
    component: () =>
      import(/* webpackChunkName: "shop" */ '../views/model.vue'),

  },
  {
    path: '/shop/details',
    name: 'Details',
    component: () =>
      import(/* webpackChunkName: "shop" */ '../views/details.vue'),

  },
  {
    path: '/shop/summary',
    name: 'Summary',
    component: () =>
      import(/* webpackChunkName: "shop" */ '../views/summary.vue'),

  },
  {
    path: '/shop/preview',
    name: 'Preview',
    component: () =>
      import(/* webpackChunkName: "shop" */ '../views/preview.vue'),

  },
  {
    path: '/shop/done',
    name: 'Done',
    component: () =>
      import(/* webpackChunkName: "shop" */ '../views/done.vue'),

  },
  ...(['prod', 'production'].includes(process.env.APP_ENV) ? [] : [
    {
      path: '/dev',
      name: 'Dev',
      component: () =>
        import(/* webpackChunkName: "shop" */ '../views/dev.vue'),
  
    },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/shop/model'

  },
  ])
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

function hasQueryParams(route: any) {
  return !!Object.keys(route.query).length;
}
router.beforeEach((to, from, next) => {
  if(!hasQueryParams(to) && hasQueryParams(from)){
   next({ name: to.name as any, query: from.query });
 } else {
   next();
 }
});

export default router;
